import cloneDeep from 'lodash/cloneDeep';
import pickBy from 'lodash/pickBy';
import zipObject from 'lodash/zipObject';

import I18N from 'assets/i18n/brandlift-project';
import {Domain} from 'types/domain';

import {SurveyPreset} from 'client/common/types';
import {YANDEX_TEMPLATES} from 'client/common/store/reducers/question-bank/consts';
import {UserRoles} from 'client/common/hooks/user';

const i18n = I18N.surveyCreate.surveyPresets;

interface PresetGroups {
    [name: string]: SurveyPreset[];
}

const PRESET_GROUPS: PresetGroups = {
    [i18n.groups.tasks]: [
        SurveyPreset.Crowd,
        SurveyPreset.Simple,
        SurveyPreset.PRO,
        SurveyPreset.CreateForMe,
        SurveyPreset.Creative,
        SurveyPreset.Bordomatik,
        SurveyPreset.UX
    ],
    [i18n.groups.yandex]: [
        SurveyPreset.YandexAdScriptTest,
        SurveyPreset.YandexAdStoryboardTest,
        SurveyPreset.YandexAdVideoTest,
        SurveyPreset.YandexNameTest,
        SurveyPreset.YandexConceptTest,
        SurveyPreset.YandexInterfaceMindfulness,
        SurveyPreset.YandexSerpSurvey,
        SurveyPreset.YandexActiveFeedback,
        SurveyPreset.YandexPassiveFeedback,
        SurveyPreset.YandexMorda
    ]
};

// https://st.yandex-team.ru/PYTHIADEV-6691
const DANGER_PRESET = [
    SurveyPreset.CompetitorAnalysis,
    SurveyPreset.DemandAssessment,
    SurveyPreset.ConceptTest,

    SurveyPreset.TestSlogans,
    SurveyPreset.CompareSlogans,
    SurveyPreset.TestVideo,

    SurveyPreset.SimpleMarketAnalysis,
    SurveyPreset.SimplePriceSensitivityMeter,
    SurveyPreset.SimpleNameTesting,
    SurveyPreset.SimpleDesignEvaluation
];

export function getPresetGroups({
    tld,
    userRoles
}: {
    tld: Domain;
    userRoles: UserRoles;
}): PresetGroups {
    const exclude: SurveyPreset[] = [];
    const presetGroupsClone = cloneDeep(PRESET_GROUPS);

    if (userRoles.isSuperuser || userRoles.isSupport) {
        presetGroupsClone[i18n.groups.tasks].push(...DANGER_PRESET);
    }

    if (!userRoles.isYandexPublisher) {
        exclude.push(...YANDEX_TEMPLATES);
    }

    if (tld !== Domain.Ru) {
        exclude.push(SurveyPreset.Creative, SurveyPreset.Bordomatik);
    }

    const groups = zipObject(
        Object.keys(presetGroupsClone),
        Object.values(presetGroupsClone).map(group =>
            group.filter(preset => !exclude.includes(preset))
        )
    );

    return pickBy(groups, group => group.length > 0);
}
